<div class="collection-view">
  <div *ngFor="let section of data?.sections" class="collection-view__sections">
    <app-editor-view
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      [value]="section.contentText"
    ></app-editor-view>

    <div class="collection-view__products">
      <lp-product-card
        *ngFor="let product of section.products"
        [product]="product"
        [collectionId]="data?.id"
        [ref]="ref"
      ></lp-product-card>
    </div>
  </div>

  <div *ngIf="allowEditing || allowDeleting" class="collection-view__buttons">
    <button
      *ngIf="allowEditing"
      tuiButton
      class="collection-view-button"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      tabindex="1"
      type="button"
      appearance="primary"
      [size]="tuiElementLargeSize"
      (click)="edit.emit()"
    >
      {{ 'common.buttons.edit' | translate }}
    </button>

    <button
      *ngIf="allowDeleting"
      tuiButton
      class="collection-view-button"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
      tabindex="2"
      type="button"
      appearance="accent"
      [size]="tuiElementLargeSize"
      (click)="delete.emit('testId')"
    >
      {{ 'common.buttons.delete' | translate }}
    </button>
  </div>
</div>
